<template>
  <div class="permission-container">
    <div class="icon-wrapper">
      <p class="">!</p>
    </div>
    <p>{{ $t("permission.message") }}</p>
    <button @click="goToLogin" class="login-button">
      {{ $t("permission.login") }}
    </button>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { clearForLogout } from "@/utils/auth";

defineProps({
  isPage: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();

function goToLogin() {
  router.push("/login");
  clearForLogout();
}
</script>

<style scoped lang="scss">
.permission-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #f8f9fa;
  min-height: calc(100dvh - 210px);

  > p {
    font-size: 16px;
    color: #6c757d;
    margin-bottom: 30px;
  }
}

.icon-wrapper {
  font-style: bold;
  margin-bottom: 20px;

  p {
    font-size: 60px;
  }
}

.login-button {
  background-color: #7dba28;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.3s;
}
</style>
